import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import Terms from "apps/payment/components/Terms";

import Str from "shared/components/Str";

import "./PurchaseButton.scss";

export const PurchaseButton = ({
	state,
	isSuccessful,
	isPurchasing,
	isRedirecting,
	willRedirect,
	isEditingInfo,
	children,
	hasPaymentToken,
}) => {
	let text = <Str>Confirm Purchase</Str>;

	if (isSuccessful) {
		text = <Str>Success!</Str>;
	}
	else if (isPurchasing) {
		if (isRedirecting) {
			text = <Str>Redirecting…</Str>;
		} else {
			text = <Str>Submitting…</Str>;
		}
	}
	else if (isEditingInfo) {
		if (hasPaymentToken) {
			text = <Str>Update info</Str>;
		} else if (isRedirecting) {
			text = <Str>Redirecting...</Str>;
		} else if (willRedirect) {
			text = <Str>Add PayPal Account</Str>;
		} else {
			text = <Str>Add info</Str>;
		}
	}
	else if (willRedirect) {
		text = <Str>Continue to PayPal</Str>;
	}

	return (
		<div className="payment-purchasebutton">
			{!isEditingInfo &&
				<Terms className="payment-purchasebutton-terms" />
			}

			<div
				className={classnames("payment-purchasebutton-buttons", {
					"payment-purchasebutton-buttons--card": !willRedirect,
				})}
			>
				<button
					className={classnames("big flatbutton payment-purchasebutton-confirm", {
						"blue": !isSuccessful && !isPurchasing,
						"gray": isPurchasing || isRedirecting,
						"green": isSuccessful,
					})}
				>
					{text}
				</button>
				{children}
			</div>

			{state === "WA" &&
				<div className="payment-purchasebutton-washington">
					Washington residents are required to pay sales or use tax on
					certain purchases. Washington law requires Washington purchasers
					to review untaxed purchases and, if any tax is owed, file a
					Washington use tax return and pay any tax due. Visit
					{" "}
					<a href="https://dor.wa.gov/consumerusetax" target="_blank" rel="noopener noreferrer">
						https://dor.wa.gov/consumerusetax
					</a>
					{" "}
					for more information. This notice is required by Engrossed House
					Bill 2163, section 205(2)(a).
				</div>
			}
		</div>
	);
};

PurchaseButton.propTypes = {
	state: PropTypes.string,
	hasPaymentToken: PropTypes.bool,
	isSuccessful: PropTypes.bool.isRequired,
	isPurchasing: PropTypes.bool.isRequired,
	willRedirect: PropTypes.bool,
	isEditingInfo: PropTypes.bool,
	isRedirecting: PropTypes.bool,
	children: PropTypes.node,
};

PurchaseButton.defaultProps = {
	state: null,
	hasPaymentToken: false,
	willRedirect: false,
	isEditingInfo: false,
	isRedirecting: false,
	children: null,
};

export default PurchaseButton;



// WEBPACK FOOTER //
// ./src/apps/payment/components/PurchaseButton.jsx